<script setup>
import { useFrontegg } from '@frontegg/vue';
import NavMain from '@/components/SideBar/NavMain.vue';
import NavSecondary from '@/components/SideBar/NavSecondary.vue';
import NavUser from '@/components/SideBar/NavUser.vue';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarMenu, SidebarMenuItem, SidebarToggleButton } from '@/components/ui/sidebar';
import TenantSwitcher from './TenantSwitcher.vue';
import SidebarRail from '../ui/sidebar/SidebarRail.vue';

const props = defineProps({
    side: { type: String, required: false },
    variant: { type: String, required: false, default: 'inset' },
    collapsible: { type: String, required: false, default: 'icon' },
    class: { type: null, required: false }
});

const { authState } = useFrontegg();
</script>

<template>
    <Sidebar v-bind="props" class="relative">
        <SidebarHeader>
            <SidebarMenu>
                <SidebarMenuItem>
                    <TenantSwitcher />
                </SidebarMenuItem>
            </SidebarMenu>
        </SidebarHeader>
        <SidebarContent>
            <NavMain />
            <NavSecondary class="mt-auto" />
        </SidebarContent>
        <SidebarFooter>
            <NavUser :user="authState.user" />
        </SidebarFooter>
        <SidebarRail />

        <!-- Toggle Button positioned over SidebarRail at breadcrumb height -->
        <SidebarToggleButton class="absolute top-11 right-0 translate-x-1/2 z-[50] group-data-[state=collapsed]:right-[-0.5rem]" />
    </Sidebar>
</template>
